/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { PrimaryKeyValue } from "./PrimaryKeyValue";
import { delegateCombine, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridSelectedKeysCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedKeysCollection, _super);
    function GridSelectedKeysCollection() {
        return _super.call(this, PrimaryKeyValue.$, 0) || this;
    }
    Object.defineProperty(GridSelectedKeysCollection.prototype, "ae", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedKeysCollection.prototype.af = function (a) {
        this.collectionChanged = delegateCombine(this.collectionChanged, a);
    };
    GridSelectedKeysCollection.$t = markType(GridSelectedKeysCollection, 'GridSelectedKeysCollection', ObservableCollection$1.$.specialize(PrimaryKeyValue.$));
    return GridSelectedKeysCollection;
}(ObservableCollection$1));
export { GridSelectedKeysCollection };
//# sourceMappingURL=GridSelectedKeysCollection.js.map
